module.exports = __webpack_public_path__ + "img/Arabic-07.dce2669d.jpg";